// extracted by mini-css-extract-plugin
module.exports = {"linksList__list":"links-list-module--links-list__list--f-y8S"};